export const LEDGER_CONNECT_TIMEOUT = 50000 // 5s
